import { LPRCameraModelsSelection } from '../../models';

export interface CameraModelSelectionState {
  allSelected: boolean;
  noneSelected: boolean;
  anySelected: boolean;
}

/*
 * Determines camera model selection state to control provider checkbox appearance:
 * - allSelected = true → checkbox checked
 * - noneSelected = true → checkbox unchecked
 * - anySelected but not all → checkbox indeterminate
 */
export function calculateCameraModelSelectionState(
  selection: LPRCameraModelsSelection,
): CameraModelSelectionState {
  let allSelected = true;
  let noneSelected = true;

  selection.cameraModels.forEach((isSelected) => {
    if (isSelected) {
      noneSelected = false;
    } else {
      allSelected = false;
    }
  });

  return { allSelected, noneSelected, anySelected: !noneSelected };
}
